<i18n src="@/locales/components/WatchersTranslate.json"></i18n>

<template>
	<div class="cbs-watcher">
		<WatcherConfig
			class="my-4"
			v-for="(watcher, index) in localWatchers"
			v-model="localWatchers[index]"
			:key="`watcher-${index}`"
			:formName="`watcher-${index}`"
			@onClickDelete="() => deleteItem(index)"
		/>

		<div class="border-dashed my-4 border rounded">
			<vs-button
				color="#fff"
				type="filled"
				class="w-full"
				text-color="rgb(30,30,30)"
				@click="addMoreWatchers"
			>{{ $t("Addmore") }}</vs-button>
		</div>
	</div>
</template>

<script>
import * as _ from "lodash";

import WatcherConfig from "./WatcherConfig";

const initWatcher = {
	content: "",
	relations: null,
	remind_unit: "day",
	remind_value: null,
	can_edittable: true
};

export default {
	name: "AddWatchersRef",
	props: {
		value: {
			type: Array,
			default: () => []
		}
	},
	components: {
		WatcherConfig
	},
	data() {
		return {
			dueUnits: [
				{ label: this.$t("TypeRepeater.Days"), value: "day" },
				{ label: this.$t("TypeRepeater.Hour"), value: "hour" }
			]
		};
	},
	computed: {
		localWatchers: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		}
	},
	methods: {
		addMoreWatchers() {
			this.localWatchers = [...this.localWatchers, _.cloneDeep(initWatcher)];
		},
		deleteItem(index) {
			this.localWatchers.splice(index, 1);
		}
	}
};
</script>
